import { render, staticRenderFns } from "./EdimensajeModals.vue?vue&type=template&id=6ba30c6c"
import script from "./EdimensajeModals.vue?vue&type=script&lang=js"
export * from "./EdimensajeModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports